import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MeResponse, UpdateSettingsRequest } from './me.model';
import { environment } from '../../../environments/environment';
import { ThemeService } from '../../core/theme/theme.service';

@Injectable({ providedIn: 'root' })
export class MeService {
  private readonly http = inject(HttpClient);
  private readonly themeService = inject(ThemeService);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/me`;

  getMe(): Observable<MeResponse> {
    return this.http.get<MeResponse>(this.baseUrl).pipe(
      tap((me) => this.themeService.hydrateFromSettings(me.settings?.themePreference))
    );
  }

  updateSettings(request: UpdateSettingsRequest): Observable<MeResponse> {
    return this.http.put<MeResponse>(`${this.baseUrl}/settings`, request).pipe(
      tap((me) => this.themeService.hydrateFromSettings(me.settings?.themePreference))
    );
  }
}
